import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "../../../../../style";
import flight2 from "assets/images/flight2.svg";
import { styleSizes } from "constants/styleSizes";

export const AccountContentContainer = styled(BasicSectionContainer)`
  min-width: 260px;
  /* -webkit-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  -moz-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  border: 1px solid ${colors.signInBorderColor}; */

  .banner {
    margin-bottom: 32px;
  }

  .accountBody {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .noBooking {
      width: 88%;
      height: 453px;
      background-image: url(${flight2});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      margin: 5%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .content {
        width: 394px;
        height: 139px;
        font-size: 24px;
        font-weight: 600;
        color: ${colors.noBookingText};
        text-align: center;
        padding-top: 20px;
      }
    }

    .cardContent {
      padding: 32px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      align-content: stretch;
      flex: 1;
      .mobileHdr {
        display: none;
        font-weight: 600;
        margin-right: 16px;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          display: inline-block;
        }
      }
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        padding: 0;
      }
      .textDesktopAndMobile {
          display: inline;
          @media (max-width: ${styleSizes.tabletBreakpoint}) and (min-width: ${styleSizes.mobileBreakpoint}) {
            display: none;
          }
        }
        .textSmallScreen {
          display: none;
          @media (max-width: ${styleSizes.tabletBreakpoint}) and (min-width: ${styleSizes.mobileBreakpoint}) {
            display: inline;
          }
        }
      .bookingTableHeader {
        justify-items: stretch;
        width: 100%;
        display: grid;
        grid-template-columns: 90px 104fr 106fr 215fr 121fr 145px;
        font-size: 16px;
        font-weight: 600;
        color: ${colors.black};
        padding: 20px 0;
        border-bottom: 1px solid ${colors.black};
        border-top: 1px solid ${colors.black};
        flex: 1;
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
            grid-template-columns: 90px 215fr 121fr 145px;
          }
        .hdrDesktop {
          display: inline;
          @media (max-width: ${styleSizes.tabletBreakpoint}) {
            display: none;
          }
        }
        .hdrSmallScreen {
          display: none;
          @media (max-width: ${styleSizes.tabletBreakpoint}) {
            display: inline;
          }
        }
        .status,
        .reservationCode,
        .rooms,
        .dates,
        .total,
        .card,
        .button {
          text-align: left;
          font-size: 16px;
          font-weight: 600;
          line-height: 21px;
          padding-right: 10px;
        }
        .reservationCode {
          @media (max-width: ${styleSizes.tabletBreakpoint}) {
            display: none;
          }
        }

        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          display: none;
        }
      }
      .dates {
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          svg {
            display: none;
          }
        }
      }

      .rooms {
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          display: none;
        }
      }

      .bookingTableContent {
        display: grid;
        grid-template-columns: 1fr;

        .trip {
          display: grid;
          grid-template-columns: 90px 104fr 106fr 215fr 121fr 145px;
          padding: 22px 0;
          border-bottom: 1px solid ${colors.borderGrey2};
          position: relative;
          
          @media (max-width: ${styleSizes.tabletBreakpoint}) {
            grid-template-columns: 90px 215fr 121fr 145px;
          }

          @media (max-width: ${styleSizes.mobileBreakpoint}) {
            grid-template-columns: 1fr;
            gap: 16px;
            border: 1px solid ${colors.accounMenuBorderColor};
            padding: 16px;
          }
          .status,
          .reservationCode,
          .rooms,
          .dates,
          .card,
          .total {
            text-align: left;
            padding-right: 10px;
          }
          .total {
            white-space: nowrap;
          }
          .dates {
            display: flex;
            flex-direction: column;
            gap: 14px;
          }
          .rooms {
            @media (max-width: ${styleSizes.tabletBreakpoint}) {
              display: none;
            }
          }
          .reservationCode {
            @media (min-width: ${styleSizes.mobileBreakpoint}) and (max-width: ${styleSizes.tabletBreakpoint}) {
              display: none;
            }
          }
          .button {
            text-align: left;
            padding-right: 0;
          }

          .dates {
            svg {
              margin-right: 8px;
            }
          }
          .status {
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              position: absolute;
              top: 16px;
              right: 16px;
              display: block;
              padding: 5px;
            }
          }

          .confirmed {
            color: ${colors.optionBackground};
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              background-color: ${colors.changeRoomTypeBackground};
            }
          }

          .incomplete {
            color: ${colors.red};
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              background-color: ${colors.ltRed};
            }
          }

          .checkedIn {
            color: ${colors.hoverBlue};
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              background-color: ${colors.lightBlue};
            }
          }

          .checkedOut {
            color: ${colors.black};
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              background-color: ${colors.lightGrey};
            }
          }

          .cancelled {
            color: ${colors.red};
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              background-color: ${colors.ltRed};
            }
          }

          .expired {
            color: ${colors.badge};
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              background-color: ${colors.ltRed};
            }
          }

          .button {
            display: flex;
            justify-content: flex-end;
          }
        }
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          gap: 24px;
          margin-bottom: 120px;
        }
      }

      .description {
        font-size: 16px;
        color: ${colors.black};
      }

      .passwordContainer {
        position: relative;
        width: 45%;
        margin: 32px 0;

        .oldPasswordLock,
        .oldPasswordUnlock {
          position: absolute;
          top: 45px;
          right: 20px;
          cursor: pointer;
        }

        .newPasswordLock,
        .newPasswordUnlock {
          position: absolute;
          top: 142px;
          right: 20px;
          cursor: pointer;
        }
      }

      .buttonContainer {
        position: relative;

        svg {
          position: absolute;
          top: -85px;
          left: 150px;
        }
      }
    }
  }
`;
